import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, OutlinedInputProps } from "@mui/material";
import { useState } from "react";

interface Props extends OutlinedInputProps {
  helperText?: string
}

function PasswordInput({ label, error, helperText, ...props }: Props) {
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword((show: boolean) => !show)

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <FormControl sx={{ width: '100%' }} variant="outlined" size="small">
      <InputLabel htmlFor="password-field" required={props.required}
        error={error}
      >{label}</InputLabel>
      <OutlinedInput
        id="password-field"
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={
                showPassword ? 'Esconder senha' : 'Mostrar senha'
              }
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        label={label}
        error={error}
        size="small"
        aria-describedby="component-error-text"
        fullWidth
        {
        ...props
        }
      />
      <FormHelperText id="component-error-text" error>{helperText}</FormHelperText>
    </FormControl>
  );
}

export default PasswordInput;